// Long enough to read as "until closed", matching the other sticky toasts
// (missed call, force away).
export const UNTIL_CLOSED_TOAST_DURATION = 8 * 3600 * 1000; // 8h
